export type ApiValidationErrors = Record<string, unknown> | string | null | undefined

const toMessage = (value: unknown) =>
  Array.isArray(value) ? value.filter(Boolean).join(' ') : String(value)

export const apiFieldErrors = (messageError: ApiValidationErrors): Record<string, string> => {
  if (!messageError || typeof messageError !== 'object') return {}

  return Object.entries(messageError).reduce((errors, [key, value]) => {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      Object.entries(value as Record<string, unknown>).forEach(([nestedKey, nestedValue]) => {
        errors[nestedKey] = toMessage(nestedValue)
      })

      return errors
    }

    const [field] = key.split('.').slice(-1)
    errors[field] = toMessage(value)

    return errors
  }, {} as Record<string, string>)
}
